<template>
    <div class="container -clients-add">
        <h1>Ajouter un membre</h1>

        <tab-set>
            <tab :header="'Individu'">
                <add-individual></add-individual>
            </tab>
            <tab :header="'Famille'">
                <add-family></add-family>
            </tab>
            <tab :header="'Personne morale'">
                <add-moral-person></add-moral-person>
            </tab>
        </tab-set>
    </div>
</template>

<script type="text/ecmascript-6">
    import TabSet from '../components/TabSet';
    import Tab from '../components/Tab';
    import AddIndividual from '../components/clients/AddIndividual';
    import AddFamily from '../components/clients/AddFamily';
    import AddMoralPerson from '../components/clients/AddMoralPerson';
    import router from '../router';
    import {create} from '../api/client';

    export default {
        components: {
            TabSet,
            Tab,
            AddFamily,
            AddIndividual,
            AddMoralPerson
        },
        data() {
            return {
                adding: false
            };
        },
        events: {
            'clients:add': async function (data) {
                if (this.adding) {
                    return;
                }

                this.adding = true;

                try {
                    data.sources = ['alpinia'];
                    const client = await create(data);
                    router.replace({
                        name: 'clients-detail',
                        params: {
                            id: client.id
                        }
                    });
                } finally {
                    this.adding = false;
                }
            }
        }
    };
</script>

<style lang="less">
    @import '~src/style/variables';

    form.-client-add {
        margin-top: @grid-gutter-width;
    }
</style>



// WEBPACK FOOTER //
// ClientsAdd.vue?09a06dd2